import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  itemDesign: {},
  containerDesign: {},
};

export const musicSlice = createSlice({
  name: 'music',
  initialState,
  reducers: {
    musicStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      // state.itemDesign = {
      //   shape: itemDesign.shape ?? 'round',
      //   border: itemDesign.border ?? 'none',
      //   borderColor: itemDesign.borderColor ?? '#000000',
      //   shadow: itemDesign.shadow ?? 'none',
      //   shadowColor: itemDesign.shadowColor ?? '#000000',
      // };
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
    },
    musicClear: () => initialState,

    musicUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    musicUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    musicUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { musicStore, musicClear, musicUpdateIsLoading, musicUpdateIsActive, musicUpdateBlockContent } = musicSlice.actions;

export const selectMusicIsLoading = (state) => state.music.isLoading;

export const selectMusicId = (state) => state.music.id;
export const selectMusicUID = (state) => state.music.uid;
export const selectMusicSID = (state) => state.music.sid;

export const selectMusicBlockContent = (state) => state.music.blockContent;
export const selectMusicBlockDesign = (state) => state.music.blockDesign;
export const selectMusicSortItems = createSelector([selectMusicBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectMusicItemDesign = (state) => state.music.itemDesign;
export const selectMusicContainerDesign = (state) => state.music.containerDesign;

export default musicSlice.reducer;
